// src/pages/EmiDueReport/components/exportEmiDueCsv.js
import commaNumber from "comma-number";
import dayjs from "dayjs";

const format = commaNumber.bindWith(",", ".");

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtDate = (val) => (val ? dayjs(val).format("DD MMM YYYY") : "-");
const fmtNum  = (val) => format(parseFloat(val || 0).toFixed(2));

/**
 * @param {object} params
 * @param {Array}   params.list      - rows from Redux state.emiDue.list
 * @param {object}  params.filters   - for customer name + date in title
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportEmiDueCsv = ({
  list,
  filters,
  title = "EMI Due List",
  filename = "emi_due_list",
}) => {
  const customerName = filters?.customerName || "";
  const dateTo       = filters?.rawTo ? dayjs(filters.rawTo).format("DD MMM YYYY") : "";

  const headers = [
    "No.", "EMI No", "Customer Name", "Contact",
    "From Date", "Last Date", "Amount",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.emi_no      || "",
    row.acc_name    || "",
    row.contact_no  || "",
    fmtDate(row.from_date),
    fmtDate(row.last_date),
    fmtNum(row.amount),
  ].map(escape));

  const grandTotal = list.reduce((s, r) => s + Number(r.amount || 0), 0);
  const totalRow   = [
    "Grand Total:", "", "", "", "", "",
    fmtNum(grandTotal),
  ].map(escape);

  const rows = [
    [title],
    ...(customerName ? [[`Customer: ${customerName}`]] : []),
    ...(dateTo       ? [[`As of: ${dateTo}`]]          : []),
    [],
    headers,
    ...dataRows,
    [],
    totalRow,
  ];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};